// Host-side banner that shows pending join requests during a live game.
// Renders nothing when there are no requests.
export default function JoinRequestBanner({ requests, onAccept, onDecline }) {
  if (!requests || requests.length === 0) return null;
  return (
    <div className="join-request-banner">
      {requests.map(r => (
        <div key={r.id} className="join-request-row">
          <div className="join-request-text">
            <strong>{r.fromName}</strong> wants to join
          </div>
          <div className="join-request-actions">
            <button
              type="button"
              className="join-request-btn join-request-accept"
              onClick={() => onAccept(r)}
            >
              Accept
            </button>
            <button
              type="button"
              className="join-request-btn join-request-decline"
              onClick={() => onDecline(r)}
            >
              Decline
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
